import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsGlobalViewsDetailsRoute: InvariantJiraRoute = {
	name: 'polaris-settings-global-views-details',
	path: '/jira/settings/products/jira-product-discovery/global-views/:viewId',
	exact: true,
};
